var t = /* @__PURE__ */ ((e) => (e.HEIGHT_DESKTOP = "meinestadt/iframe#height", e.HEIGHT_MOBILE = "meinestadt/iframe#heightMobile", e.HEIGHT_TABLET = "meinestadt/iframe#heightTablet", e.URL_DESKTOP = "meinestadt/iframe#desktopUrl", e.URL_MOBILE = "meinestadt/iframe#mobileUrl", e.URL_TABLET = "meinestadt/iframe#tabletUrl", e.WAIT_FOR_CONSENT = "meinestadt/iframe#waitForConsent", e))(t || {});
export {
  t as Properties
};
